import React, { lazy, Suspense } from "react";
import { Navigate, Route } from "react-router-dom";
import CustomLoading from "../../../Components/GeneralComponents/CustomLoading/customloading";
import { CORPORATE_ROUTES } from "../constants/corporateConstants";

const CorporateDashboardPage = lazy(() => import("../pages/CorporateDashboardPage"));
const EmployeesPage = lazy(() => import("../pages/EmployeesPage"));
const OrdersPage = lazy(() => import("../pages/OrdersPage"));

function CorporatePageSuspense({ label, children }) {
  return (
    <Suspense fallback={<CustomLoading label={label} overlay size="large" />}>{children}</Suspense>
  );
}

/** Dashboard shell routes — search lives under CorporateSearchLayout. */
export const corporateNestedRoutes = (
  <>
    <Route index element={<Navigate to="dashboard" replace />} />
    <Route
      path="dashboard"
      element={
        <CorporatePageSuspense label="טוען לוח בקרה...">
          <CorporateDashboardPage />
        </CorporatePageSuspense>
      }
    />
    <Route
      path="employees"
      element={
        <CorporatePageSuspense label="טוען עובדים...">
          <EmployeesPage />
        </CorporatePageSuspense>
      }
    />
    <Route
      path="orders"
      element={
        <CorporatePageSuspense label="טוען הזמנות...">
          <OrdersPage />
        </CorporatePageSuspense>
      }
    />
    <Route path="*" element={<Navigate to={CORPORATE_ROUTES.DASHBOARD} replace />} />
  </>
);
